<template>
    <div class="ranking-table w-100">
        <ul class="table-head">
            <li>{{ $t('home.position') }}</li>
            <li>{{ $t('home.player') }}</li>
            <li class="ml-auto">{{ $t('home.accumulated_xp') }}</li>
        </ul>
        <!-- USER POSITION -->
        <!-- <div class="row ma-0 user-position mb-4 flex-nowrap align-items-center">
            <span class="user-position_title">{{ $t('home.your_position') }}</span>
            <div class="user-position_top text-center">2836</div>
            <div class="col-auto px-0 px-md-3">
                <v-img
                    :src="require('@/assets/img/icons/xp-coin.png')"
                    height="32"
                    width="32"
                ></v-img>
            </div>
            <div class="col-auto user-position_user-name">Nombre de Usuario</div>
            <div class="text-xp col-auto ml-auto">
                <span>1234456</span>
                <v-img
                    :src="require('@/assets/img/icons/xp-coin.png')"
                    height="25"
                    width="25"
                ></v-img>
            </div>
        </div> -->
        <v-simple-table class="ranking-table-content mb-4">
            <tbody>
                <tr
                    v-for="(item, index) of list_data"
                    :key="index"
                >
                    <td width="5%" class="pr-0 font-weight-bolder"> {{ index + 4 }} </td>
                    <td width="5%" class="pr-0">
                        <img
                            :src="`https://assets.beeverso.org/avatar/${item.avatar.name}/${item.avatar.value}`"
                            alt=""
                            height="32"
                            width="32"
                        />
                    </td>
                    <td class="text-left font-weight-medium">{{ setName(item) }}</td>
                    <td class="text-right text-xp">
                        <span>{{ item.points }}</span>
                        <v-img
                            :src="require('@/assets/img/icons/xp-coin.png')"
                            height="25"
                            width="25"
                        ></v-img>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>
<script>
import PointHexagone from '@/components/core/PointHexagone.vue'

export default {
    props: {
        list_data: { type: Array, default: null },
    },
    components: {
        PointHexagone,
    },
    data() {
        return {
            gradient: {
                radial: false,
                colors: [
                    {
                        color: '#FFDA00',
                        offset: '0',
                        opacity: '1',
                    },
                    {
                        color: '#FFC400',
                        offset: '100',
                        opacity: '1',
                    },
                ],
            },
        }
    },
    methods: {
        setName(data) {
            return `${this.capitalizeText(data.firstName.split(' ')[0])} ${this.capitalizeText(
                data.lastName.split(' ')[0]
            )}`
        },
        capitalizeText(text) {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
        },
    },
}
</script>

<style lang="scss">
.position-text {
    font-size: 48px;
    z-index: 10;
    text-align: center;
    left: 2.5vh;
    width: 5vh;
}
.v-data-table.ranking-table-content {
    background: #f6f5fc;
    border-radius: 10px;
    color: #323A46;
}

.ranking-line {
    border-bottom: 1px solid #ebebeb;
}

.point-color {
    color: #816ad6;
}
.text-xp{
    span{
        display: inline-flex;
        font-weight: 600;
        & + .v-image{
            align-items: center;
            display: inline-flex;
            margin-left: 5px;
            vertical-align: text-bottom;
        }
    }
}
ul.table-head{
    align-items: center;
    display: flex;
    list-style: none;
    margin: 0;
    padding-left: 0;
    li{
        font-weight: 600;
        font-size: .875em;
        color: #A0ABBB;
        padding: 20px 10px;
    }
}
.user-position{
    background: linear-gradient(270deg, #7764CA 0%, #A295DA 34.22%, #6857B2 71.35%, #514585 100%);
    border-radius: 10px;
    color: #fff;
    padding: 4px 8px;
    position: relative;
    &_user-name{
        font-weight: 500;
        padding-left: 5px;
    }
    &_top{
        font-weight: 600;
        flex: 0 0 7%;
        max-width: 7%;
        padding: 12px;
        white-space: nowrap;
        @media screen and (max-width: 960px) {
            flex: 0 0 auto;
            max-width: 100%;
            padding: 12px 6px;
            width: auto;
        }
    }
    &_title{
        background: #514585;
        border-radius: 4px;
        box-shadow: 0px 0px 4px 0px #0000001A;
        color: white;
        font-size: .75em;
        font-weight: 600;
        left: 50%;
        top: -10px;
        padding: 2px 14px;
        position: absolute;
        transform: translateX(-50%);
        text-transform: uppercase;
    }
}
</style>
